import { setSpecificMessage, maxGraphemes } from "valibot";
setSpecificMessage(
  maxGraphemes,
  (issue) => `Graphèmes invalide: attendu ${issue.expected}, mais reçu ${issue.received}`,
  "fr"
);